import Portaal from "../components/Portaal";
import SideNav from "../components/SideNav";

export default function PortaalPage() {
  return (
    <>
      <SideNav />
      <Portaal />
    </>
  );
}